import i18n from '@/i18n';

const FIELD_TYPE_LABEL_KEYS = {
  Text: 'bulkUpload.fieldTypes.text',
  Email: 'bulkUpload.fieldTypes.email',
  Date: 'bulkUpload.fieldTypes.date',
  Number: 'bulkUpload.fieldTypes.number',
  Currency: 'bulkUpload.fieldTypes.currency',
};
// Display only — `field.type` itself must stay one of the English literals above,
// since isNumberFieldType()/hasDateField/handleDateFormat all match against it directly.

export const getFieldTypeLabel = type => (FIELD_TYPE_LABEL_KEYS[type] ? i18n.t(FIELD_TYPE_LABEL_KEYS[type]) : type);
